export const METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    HEAD: 'HEAD',
    DELETE: 'DELETE'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/api/constants.js